import {modifyPageLayoutComponents} from "../PageLayout";
import {ESignatureComponent} from "./eSignature";

export const ESignatureComponents = modifyPageLayoutComponents({
  content: ESignatureComponent
});
